import React, { useState } from "react";
import { FiFilter, FiChevronDown, FiChevronUp } from "react-icons/fi";

function Filtersidebar({
  filterData,
  filters,
  onFilterChange,
  onCheckboxChange,
  priceRange,
  onPriceChange,
  onApply,
}) {
  const [showAllCategories, setShowAllCategories] = useState(false);
  const [showAllBrands, setShowAllBrands] = useState(false);

  return (
    <>
      <div className="luxury-filter-sidebar-wrapper p-4">
        
        {/* SIDEBAR MAIN HEADLINE ACCENT */}
        <div className="luxury-filter-main-header d-flex align-items-center gap-2 mb-4 pb-3 border-bottom-split">
          <FiFilter size={16} strokeWidth={2.5} className="text-dark" />
          <h5 className="sidebar-title-text mb-0">Refine Collection</h5>
        </div>

        {/* SEGMENT 1: CATEGORIES EXPANDABLE PANEL */}
        <div className="luxury-filter-section-block mb-4 pb-3 border-bottom-split">
          <label className="luxury-filter-section-label mb-3">Shop by Category</label>
          <div className="luxury-checkbox-stack-list">
            {(showAllCategories
              ? filterData?.categories
              : filterData?.categories?.slice(0, 7)
            )?.map((cat) => (
              <label className="luxury-custom-checkbox-row d-flex align-items-center mb-2" key={cat._id}>
                <input
                  type="checkbox"
                  name="category"
                  id={`cat-${cat._id}`}
                  value={cat._id}
                  checked={filters.category.includes(cat._id)}
                  onChange={() => onCheckboxChange("category", cat._id)}
                  className="luxury-native-checkbox"
                />
                <span className="luxury-custom-indicator-box" />
                <span className="checkbox-string-label-text ms-3">{cat.name}</span>
              </label>
            ))}
          </div>
          
          {filterData?.categories?.length > 7 && (
            <div 
              className="luxury-view-more-toggle-trigger mt-3 d-inline-flex align-items-center gap-1"
              onClick={() => setShowAllCategories((prev) => !prev)}
            >
              <span>{showAllCategories ? "Show Less" : "View More Categories"}</span>
              {showAllCategories ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
            </div>
          )}
        </div>

        {/* SEGMENT 2: BRANDS EXPANDABLE PANEL */}
        <div className="luxury-filter-section-block mb-4 pb-3 border-bottom-split">
          <label className="luxury-filter-section-label mb-3">Brands</label>
          <div className="luxury-checkbox-stack-list">
            {(showAllBrands
              ? filterData?.brands
              : filterData?.brands?.slice(0, 7)
            )?.map((b) => (
              <label className="luxury-custom-checkbox-row d-flex align-items-center mb-2" key={b.id}>
                <input
                  type="checkbox"
                  name="brand"
                  id={`brand-${b.id}`}
                  value={b.id}
                  checked={filters.brand.includes(b.id)}
                  onChange={() => onCheckboxChange("brand", b.id)}
                  className="luxury-native-checkbox"
                />
                <span className="luxury-custom-indicator-box" />
                <span className="checkbox-string-label-text ms-3">{b.name}</span>
              </label>
            ))}
          </div>
          
          {filterData?.brands?.length > 7 && (
            <div 
              className="luxury-view-more-toggle-trigger mt-3 d-inline-flex align-items-center gap-1"
              onClick={() => setShowAllBrands((prev) => !prev)}
            >
              <span>{showAllBrands ? "Show Less" : "View More Brands"}</span>
              {showAllBrands ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
            </div>
          )}
        </div>

        {/* SEGMENT 3: DUAL SLIDER PRICE RANGE SELECTOR */}
        <div className="luxury-filter-section-block mb-5">
          <label className="luxury-filter-section-label mb-4">Price Range</label>
          
          <div className="luxury-range-slider-holder position-relative mb-4">
            <input
              type="range"
              className="luxury-native-range-input-thumb"
              min={filterData?.priceRange?.min || 0}
              max={filterData?.priceRange?.max || 10000}
              value={priceRange[0]}
              onChange={(e) => {
                const val = Math.min(+e.target.value, priceRange[1] - 100);
                onPriceChange([val, priceRange[1]]);
              }}
            />
            <input
              type="range"
              className="luxury-native-range-input-thumb"
              min={filterData?.priceRange?.min || 0}
              max={filterData?.priceRange?.max || 10000}
              value={priceRange[1]}
              onChange={(e) => {
                const val = Math.max(+e.target.value, priceRange[0] + 100);
                onPriceChange([priceRange[0], val]);
              }}
            />
            <div
              className="luxury-slider-active-track-bar"
              style={{
                left: `${
                  ((priceRange[0] - (filterData?.priceRange?.min || 0)) /
                    ((filterData?.priceRange?.max || 10000) -
                      (filterData?.priceRange?.min || 0))) *
                  100
                }%`,
                right: `${
                  100 -
                  ((priceRange[1] - (filterData?.priceRange?.min || 0)) /
                    ((filterData?.priceRange?.max || 10000) -
                      (filterData?.priceRange?.min || 0))) *
                  100
                }%`,
              }}
            />
          </div>
          
          {/* Explicit Price Box Swatches Outputs */}
          <div className="luxury-price-numeric-values-row d-flex justify-content-between align-items-center">
            <div className="price-bound-box-pill"><span>Min</span> <strong>₹{priceRange[0]}</strong></div>
            <div className="price-split-dash-separator" />
            <div className="price-bound-box-pill"><span>Max</span> <strong>₹{priceRange[1]}</strong></div>
          </div>
        </div>

        {/* SEGMENT 4: SORTING ENGINE CONFIGURATION */}
        {filterData?.sorting && filterData.sorting.length > 0 && (
          <div className="luxury-filter-section-block pt-3 border-top-split">
            <label className="luxury-filter-section-label mb-3">Sort Results</label>
            <div className="luxury-checkbox-stack-list">
              {filterData.sorting.map((opt, i) => (
                <label className="luxury-custom-checkbox-row d-flex align-items-center mb-2" key={i}>
                  <input
                    type="checkbox"
                    name="sort"
                    id={`sort-${i}`}
                    value={opt.value}
                    checked={filters.sort === opt.value}
                    onChange={(e) => onFilterChange("sort", e.target.value)}
                    className="luxury-native-checkbox"
                  />
                  <span className="luxury-custom-indicator-box rounded-circle-custom" />
                  <span className="checkbox-string-label-text ms-3">{opt.label}</span>
                </label>
              ))}
            </div>
          </div>
        )}

      </div>
    </>
  );
}

export default Filtersidebar;